import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import VueSignalR from '@latelier/vue-signalr'
import vuetify from './plugins/vuetify'
import wb from './registerServiceWorker'
import axios from 'axios'
import store from './store'
import VueAxios from 'vue-axios'
// import Signal from './signalr'
import AudioVisual from 'vue-audio-visual'
// import './zoodKomakHub'
import VueChatScroll from 'vue-chat-scroll'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
// Vue.use(VueSignalR, 'http://zoodconcert.com/signalr');
import VueSimpleContextMenu from 'vue-simple-context-menu'

// Vue.use(VueSignalR, 'SOCKET_URL');
import VueI18n from 'vue-i18n'

import i18n from './i18n'

// import firebaseMessaging from './configFirebase'
// Vue.prototype.$messaging = firebaseMessaging

Vue.use(Autocomplete)
Vue.use(VueChatScroll)
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)
export const bus = new Vue()
Vue.use(AudioVisual)
// import firebase from 'firebase'
// Vue.use(Signal)
Vue.use(VueAxios, axios)
Vue.prototype.$workbox = wb

Vue.use(VueI18n)
Vue.mixin({
    methods: {
calculate_items(list,key){
  var total = 0;
  list.forEach(function (val) {
total = total + val[key];
  })
  return total;
},
      postNavigator(message) {
        // navigator.serviceWorker.controller.postMessage(message)
        return new Promise(function(resolve, reject) {
          var messageChannel = new MessageChannel();
          messageChannel.port1.onmessage = function(event) {
            if (event.data.error) {
              reject(event.data.error);
            } else {
              resolve(event.data);
            }
          };

          // This sends the message data as well as transferring messageChannel.port2 to the service worker.
          // The service worker can then use the transferred port to reply via postMessage(), which
          // will in turn trigger the onmessage handler on messageChannel.port1.
          // See https://html.spec.whatwg.org/multipage/workers.html#dom-worker-postmessage
          navigator.serviceWorker.controller.postMessage(message,
            [messageChannel.port2]);
        });
        // wb..controller.postMessage(message);
        // wb.clients.matchAll({ includeUncontrolled: true }).then(clients => {
        //   clients.forEach(client => client.postMessage(message));
        // })
        // return this.clients.matchAll().then(function (clients) {
        //   clients.forEach(function (client) {
        //     client.postMessage(message)
        //   });
        // });
      },
      get_currency(number) {
        var final_number = parseFloat(number);
        number = final_number.toFixed(0);
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      toEnglishDigits(str) {
        const persianNumbers = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"]
        const arabicNumbers = ["١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "٠"]
        const englishNumbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]
        return str.split("").map(c => englishNumbers[persianNumbers.indexOf(c)] ||
          englishNumbers[arabicNumbers.indexOf(c)] || c).join("")
      },

      replace_fa_numbers (number) {
        // bus.$emit('show_toast', [1500, number])

        const myArr = number.split("");
        const persianNumbers = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"]
        const arabicNumbers = ["١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "٠"]
        const englishNumbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]
        for (var i = 0; i < myArr.length; i++) {
          for (var x = 0; x < persianNumbers.length; x++) {
            if (myArr[i] == persianNumbers[x]) {
              myArr[i] = englishNumbers[x];
            }
            if (myArr[i] == arabicNumbers[x]) {
              myArr[i] = englishNumbers[x];
            }
          }
        }
       var last_string = "";
        for (var i = 0; i < myArr.length; i++) {
          last_string += myArr[i]
        }
        // bus.$emit('show_toast', [1500, last_string])

        return last_string;
      },
      persian_to_english (number) {
        // return this.replace_fa_numbers(number);

        number = this.toEnglishDigits(number);
        number = number.replace(/۱/g, "1");
        number = number.replace(/۲/g, "2");
        number = number.replace(/۳/g, "3");
        number = number.replace(/۴/g, "4");
        number = number.replace(/۵/g, "5");
        number = number.replace(/۶/g, "6");
        number = number.replace(/۷/g, "7");
        number = number.replace(/۸/g, "8");
        number = number.replace(/۹/g, "9");
        number = number.replace(/۰/g, "0");

        number = number.replace(/١/g, "1");
        number = number.replace(/٢/g, "2");
        number = number.replace(/٣/g, "3");
        number = number.replace(/٤/g, "4");
        number = number.replace(/٥/g, "5");
        number = number.replace(/٦/g, "6");
        number = number.replace(/٧/g, "7");
        number = number.replace(/٨/g, "8");
        number = number.replace(/٩/g, "9");
        number = number.replace(/٠/g, "0");
        // bus.$emit('show_toast', [1500, number])

        return number;
      },
      get_user_image(){
        var user_data = JSON.parse(localStorage.getItem('profile'));
        var user_image = user_data.ThumbPath
        return user_image;
      }
    }
  }
)

// i18n.locale = 'en'
i18n.locale = 'fa'
axios.defaults.baseURL = 'https://panel.zoodkomak.com/ZkpWebService'
// axios.defaults.baseURL = 'https://test.zoodkomak.com/ZkpWebService'
// axios.defaults.baseURL = 'http://zoodconcert.com/ZkpWebService'
// axios.defaults.baseURL = 'http://192.168.30.11:5040/ZkpWebService'
axios.interceptors.request.use(
  config => {
    if (config.show_pros == null) {
      bus.$emit('show_spinner', 'true')
    }

    return config
  },
  error => {
    // trigger 'loading=false' event here
    console.log('axios false')
    bus.$emit('show_spinner', 'false')

    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    // trigger 'loading=false' event here
    bus.$emit('show_spinner', 'false')

    return response
  },
  error => {
    // trigger 'loading=false' event here
    bus.$emit('show_spinner', 'false')

    return Promise.reject(error)
  }
)

Vue.config.productionTip = false
new Vue({
  router,
  vuetify,
  store,
  i18n,

  // created() {
  //   this.$socket.start({
  //     log: true // Active only in development for debugging.
  //   });
  // },
  render: h => h(App)
}).$mount('#app')
